import React from 'react';
import { TruckIcon, ClockIcon, RotateCcwIcon, InfinityIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
import { assurances, shippingNote } from '../data/product';
import { CtaButton } from './CtaButton';
const icons = {
  ship: TruckIcon,
  clock: ClockIcon,
  return: RotateCcwIcon,
  infinity: InfinityIcon
};
export function AssuranceSection() {
  return <section id="shipping" className="scroll-mt-28 border-b border-white/10 bg-ink-900" data-id="element-29" data-mp="2plnk025znutm">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-30" data-mp="2lmxx9iz290xb">
        <h2 className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-31" data-mp="2gls1tde0mzk3">
          Nothing to lose
          <br data-id="element-32" data-mp="157wpsdier6x3" />
          <span className="text-grit-500" data-id="element-33" data-mp="158fw0wyp46va">on this order.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-34" data-mp="155k0tge8fwaj">
          Ships fast from the U.S. Send it back inside 30 days if it&apos;s not for you. Break it later and we
          replace it. Terms apply.
        </p>

        <ul className="mt-10 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-35" data-mp="aoq7zibkyt9g">
          {assurances.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex h-full flex-col bg-ink-950 p-6" data-id="element-36" data-mp="1n9wf7914l3n">
                <Icon className="h-8 w-8 text-grit-500" aria-hidden="true" data-id="element-37" data-mp="1pcu8dgfbiix" />
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight text-offwhite" data-id="element-38" data-mp="3j2qh2fnh5ghg">
                  {item.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-steel-400" data-id="element-39" data-mp="3a4ei9qcgfcdx">{item.body}</p>
              </li>;
        })}
        </ul>

        <div className="mt-8 grid gap-px border border-white/10 bg-white/10 lg:grid-cols-2" data-id="element-40" data-mp="3f025w1bafxhb">
          <div className="bg-ink-950 p-6 lg:p-7" data-id="element-41" data-mp="3078no84mt38y">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-grit-500" data-id="element-42" data-mp="35378xmuny555">How it ships</p>
            <div className="mt-4" data-id="element-43" data-mp="2m0ovknwnsdit">
              <UspsBadge data-id="element-44" data-mp="2m1qbp6sj7q7e" />
            </div>
            <p className="mt-3 text-[15px] leading-relaxed text-steel-400" data-id="element-45" data-mp="2h8ne8nkmvwlx">{shippingNote}</p>
          </div>

          <div className="bg-ink-950 p-6 lg:p-7" data-id="element-46" data-mp="2cavnhwvq6gjb">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-grit-500" data-id="element-47" data-mp="2c7hj6j3i3x98">Secure checkout</p>
            <div className="mt-4 flex items-center gap-3" data-id="element-48" data-mp="34yhoqyhhd930">
              <LockIcon className="h-6 w-6 shrink-0 text-offwhite" aria-hidden="true" data-id="element-49" data-mp="34xzm9k485ymn" />
              <p className="font-display text-xl font-bold uppercase leading-tight tracking-wide text-offwhite" data-id="element-50" data-mp="300pzkc88012i">
                256-bit SSL encrypted payment
              </p>
            </div>
            <p className="mt-3 text-[15px] leading-relaxed text-steel-400" data-id="element-51" data-mp="2q079v0tz5qco">
              Your card details are encrypted end to end and processed by our PCI DSS compliant payment provider. We
              never see or store your card number.
            </p>
            <div className="mt-5" data-id="element-52" data-mp="3q9f7wocrjk5v">
              <PaymentLogos data-id="element-53" data-mp="3qaglp0l5ykra" />
            </div>
            <ul className="mt-5 grid gap-2 border-t border-white/10 pt-4 sm:grid-cols-2" data-id="element-54" data-mp="3q7kpphsvm65h">
              {['Verified by Visa and Mastercard SecureCode', 'Fraud protection on every order', 'No card details stored on our servers', 'Full refund inside 30 days'].map(line => <li key={line} className="flex items-start gap-2 text-[13px] font-medium text-steel-300" data-id="element-55" data-mp="dr8nlqn8wkuo">
                  <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grit-500" aria-hidden="true" data-id="element-56" data-mp="hs0yeobrmxt2" />
                  {line}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 flex justify-start" data-id="element-57" data-mp="rr08mbc6j1i6">
          <CtaButton className="w-full sm:w-auto" data-id="element-58" data-mp="2okl7z3kkxork">Get your X1 risk free</CtaButton>
        </div>
      </div>
    </section>;
}